module.exports = __webpack_public_path__ + "img/jet_blue.447f8093.png";